import { DetailedHTMLProps, ButtonHTMLAttributes, ComponentType } from "react";

import styles from "./PhotoActionButton.module.scss";

export default function PhotoActionButton({
  Icon,
  ...props
}: DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  Icon: ComponentType<any>;
}) {
  return (
    <button className={styles.button} type="button" {...props}>
      <Icon className={styles.icon} />
      {props.children}
    </button>
  );
}
